import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import OrderDashboardDemoDialog from '../../OrderDashboard/dialogs/DemoDialog';

class DemoDialog extends React.Component {
  render() {
    return (
      <OrderDashboardDemoDialog {...this.props} />
    );
  }
}

DemoDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles()(DemoDialog);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/dialogs/DemoDialog.jsx